export default function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="grain relative overflow-hidden">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-brand-ink via-brand-ink/85 to-brand-ink/40" />
        </>
      )}
      <div className="relative mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:py-32">
        <p className="eyebrow animate-fade-up">{eyebrow}</p>
        <h1 className="mt-4 max-w-3xl font-display text-4xl font-extrabold uppercase leading-none tracking-tight text-white animate-fade-up sm:text-5xl lg:text-6xl" style={{ animationDelay: "0.1s" }}>
          {title}
        </h1>
        {subtitle && <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 animate-fade-up sm:text-lg" style={{ animationDelay: "0.2s" }}>{subtitle}</p>}
      </div>
    </section>
  );
}
